// edit-mode detection + button UI

document.addEventListener('DOMContentLoaded', async () => {
  const params = new URLSearchParams(window.location.search);
  const isEdit = params.get('edit_cart') === 'true';
  const lineKey = params.get('line');

  if (!isEdit || !lineKey) return;

  const productForm = document.querySelector('product-form');
  if (!productForm) return;

  /* Fetch cart */
  const cart = await fetch('/cart.js').then(r => r.json());
  const editingLine = cart.items.find(item => item.key === lineKey);
  if (!editingLine) return;

  /* Store edit state */
  productForm.dataset.editCart = 'true';
  productForm.dataset.lineKey = lineKey;
  productForm.dataset.originalVariantId = String(editingLine.variant_id);
  productForm.dataset.originalQuantity = editingLine.quantity;

  /* Pre-fill quantity input with current cart quantity */
  const qtyInput = productForm.querySelector('input[name="quantity"]') ||
    productForm.querySelector('.quantity__input') ||
    productForm.querySelector('input[type="number"]');
  
  if (qtyInput) {
    qtyInput.value = editingLine.quantity;
  }

  /* Change button text */
  const submitBtnText = productForm.querySelector(
    'button[type="submit"] span'
  );
  if (submitBtnText) {
    submitBtnText.textContent = 'Update Cart';
  }

  /* Hide Buy Now */
  const buyNow = productForm.querySelector('.shopify-payment-button');
  if (buyNow) {
    buyNow.style.display = 'block';
  }
});


/* ============================= */
/* Handle UPDATE CART submit     */
/* ============================= */

document.addEventListener('DOMContentLoaded', async () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('edit_cart') !== 'true') return;

  const lineKey = params.get('line');
  if (!lineKey) return;

  const cart = await fetch('/cart.js').then(r => r.json());
  const line = cart.items.find(item => item.key === lineKey);
  if (!line) return;

  const productForm = document.querySelector('product-form');
  if (!productForm) return;

  productForm.dataset.originalVariantId = String(line.variant_id);
});


document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[data-type="add-to-cart-form"]');
  if (!form) return;

  const productForm = form.closest('product-form');
  if (!productForm?.dataset.editCart) return;

  e.preventDefault();

  const lineKey = productForm.dataset.lineKey;
  const originalVariantId = productForm.dataset.originalVariantId;
  const newVariantId = String(form.querySelector('[name="id"]').value);

  let quantity = 1;
  
  // Try multiple ways to find the quantity input
  const qtyInput =
    productForm.querySelector('input[name="quantity"]') ||
    productForm.querySelector('.quantity__input') ||
    productForm.querySelector('input[type="number"]') ||
    productForm.querySelector('quantity-input input') ||
    document.querySelector('input[name="quantity"]');

  if (qtyInput?.value) {
    quantity = parseInt(qtyInput.value, 10);
  }

  const cart = await fetch('/cart.js').then(r => r.json());

  /* ============================= */
  /* SAME VARIANT → REPLACE QTY    */
  /* ============================= */
  if (originalVariantId === newVariantId) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity
      }),
    });

    window.location.href = '/cart';
    return;
  }

  const existingLine = cart.items.find(
    item => String(item.variant_id) === newVariantId
  );

  /* Remove old line */
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: lineKey,
      quantity: 0
    }),
  });

  /* Replace quantity (NOT add) */
  if (existingLine) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: existingLine.key,
        quantity
      }),
    });
  }

  window.location.href = '/cart';
});


/* ============================= */
/* Enforce Update Cart Button    */
/* ============================= */

function enforceUpdateCartButton() {
  const productForm = document.querySelector('product-form');
  if (!productForm?.dataset.editCart) return;

  const submitBtnText = productForm.querySelector(
    'button[type="submit"] span'
  );

  if (submitBtnText && submitBtnText.textContent !== 'Update Cart') {
    submitBtnText.textContent = 'Update Cart';
  }
}

/* Re-apply on variant change */
document.addEventListener('change', (e) => {
  // Variant radios / selects
  if (
    e.target.matches('[name="id"]') ||
    e.target.closest('[data-variant-input]')
  ) {
    setTimeout(enforceUpdateCartButton, 0);
  }
});

/* Re-apply if theme fires custom variant event */
document.addEventListener('variant:change', () => {
  setTimeout(enforceUpdateCartButton, 0);
});